const pathBase = location.pathname.split("/")[1].replace(/\?$/, "");
const base = pathBase.toLowerCase() === "workflow" ? "/workflow" : "";

const iconBase = base + "/icons";

export function metadata(name: string) {
  return `${base}/metadata/${name}`;
}

export function user(s: string) {
  return `${base}/user/${s}`;
}

export function view(
  definitionName: string,
  definitionVersion: string,
  viewName: string,
  resourcesVersion: string
): string {
  return `${base}/view/${definitionName}/${definitionVersion}/${viewName}?v=${resourcesVersion}`;
}

export function sharedView(viewPath: string, resourcesVersion: string): string {
  return `${base}/sview/${viewPath}?v=${resourcesVersion}`;
}

export function ui(callName: string): string {
  return `${base}/ui/${callName}`;
}

export function infrastructure(callName: string): string {
  return `${base}/infrastructure/${callName}`;
}

export function publicResources(path: string) {
  return `${base}/public/resources/${path}`;
}

export function worktrayView(path: string) {
  return `${base}/worktrayview/${path}`;
}

export function nonPublicResources(path: string) {
  return `${base}/resources/${path}`;
}

export function basePath() {
  return base;
}

// not sure if these will remain here... also not sure what their replacement(s) would be
export function getExtension(s: string): string {
  return s.indexOf(".") > -1 ? s.split(".").pop() : "";
}

export function fileName(s: string): string {
  return s.indexOf("\\") > -1 ? s.split("\\").pop() : s;
}

export function icon(fileName: string): string {
  var extension = getExtension(fileName);
  return `${iconBase}/${32}/${extension}.png`;
}

export function defaultIcon(): string {
  return `${iconBase}/${32}/default.png`;
}

export function download(fileId, workItemId): string {
  return `${base}/download/${fileId}/${workItemId}`;
}

export function fullImage(fileId: string, workItemId: string): string {
  return `${base}/image/${fileId}/${workItemId}`;
}

export function sizedImage(
  fileId: string,
  workItemId: string,
  width: number,
  height: number
): string {
  return `${base}/image/${width}x${height}/${fileId}/${workItemId}`;
}

export function getFileNameWithoutExtension(s: string): string {
  return s.replace(/\.[^/.]+$/, "");
}

export function silverlightImageCapture(): string {
  return `${base}/ClientBin/SAM.Web.ImageCapture.xap`;
}

export function downloadActivityResult(filename: string, key: string): string {
  return `${ui("activityresultdownload")}/${filename}/${key}`;
}

export function api(callName: string): string {
  return `${base}/api/${callName}`;
}

export function system(callName: string): string {
  return `${base}/system/${callName}`;
}
